import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchOverlayService {
  private readonly openRequestedSubject = new Subject<void>();
  private readonly featureActiveSubject = new BehaviorSubject<boolean>(false);

  readonly openRequested$ = this.openRequestedSubject.asObservable();
  readonly featureActive$ = this.featureActiveSubject.asObservable();

  open(): void {
    this.openRequestedSubject.next();
  }

  setFeatureActive(isActive: boolean): void {
    this.featureActiveSubject.next(isActive);
  }
}
